import { RelayEnvironment } from '@/RelayEnvironment';
import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { RelayEnvironmentProvider } from 'react-relay/hooks';
import { useUserStore } from './defines/store/userStore';

export const TokenProvider = ({ children }: { children: React.ReactNode }) => {
    const { getToken, isSignedIn, isLoaded } = useAuth();
    const updateToken = async () => {

        if (!isLoaded) {
            return null
        }

        if (isSignedIn) {
            getToken({ template: 'hasura' }).then((token) => {
                useUserStore.setState({ token: token ?? '' });
            });
        }
        else {
            useUserStore.setState({ token: '' });
        }
    };

    useEffect(() => {
        updateToken();
        setInterval(updateToken, 1000 * 30);
    }, [getToken, isSignedIn]);

    updateToken();

    return (
        <RelayEnvironmentProvider environment={RelayEnvironment}>
            {children}
        </RelayEnvironmentProvider>
    );
};
